import React, { useEffect, useState } from "react";
import DashboardContainer from "../../components/dashboard-container";
import CircularProgress from "@mui/material/CircularProgress";
import { Box } from "@mui/material";
import CustomPagination from "../../components/pagination";
import ShippingServiceMapModal from "../../components/shipping-service-map-modal";
import { supplierClientMapService } from "../../utils/services/supplier-client-map.service";
import ShippingServiceMapList from "../../components/shipping-service-map-list";
import SupplierClientMapList from "../../components/supplier-client-map";
import SupplierClientMapModal from "../../components/supplier-client-map-modal";

export default function SupplierClientMap() {
  const [shippingServiceMapData, setShippingServiceMapData] = useState([]);
  const [selectedClientMapping, setSelectedClientMapping] = useState(null);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [dataCount, setDataCount] = useState(rowsPerPage);
  const [openModal, setOpenModal] = useState(false);
  const [selectedClient, setSelectedClient] = useState({ name: "" });
  const [searchValue, setSearchValue] = useState("");
  const [clientFilter, setClientFilter] = useState(null);
  const clientId = localStorage.getItem("client_id");
  const [viewMode, setViewMode] = useState("list");

  const fetchSupplierClientMap = async () => {
    setLoading(true);
    try {
      const skip = page * rowsPerPage;
      const response = await supplierClientMapService.fetch(
        clientId ? clientId : clientFilter?._id,
        searchValue,
        rowsPerPage,
        skip
      );
      setShippingServiceMapData(response.data);
      setDataCount(response?.total);
    } catch (error) {
      console.error("Fetch failed:", error);
      // Handle fetch failure
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchSupplierClientMap();
  }, [page, rowsPerPage, clientFilter, searchValue]);

  const NoDataImage = () => (
    <div
      style={{
        width: "100%",
        justifyContent: "center",
        display: "flex",
      }}
    >
      <img
        src="no_data.png"
        alt="No data available"
        style={{ objectFit: "cover", height: "340px" }}
      />
    </div>
  );

  return (
    <DashboardContainer
      filterButton={false}
      searchBarPlaceholder={"Search by service"}
      hideFilterClient
      onSearchData={(x) => {
        setSearchValue(x);
        setPage(0);
      }}
      onClickAddButton={() => setOpenModal(true)}
      hideUploadButton={true}
      header={"Supplier Client Map"}
      onSelectClient={(e) => {
        setClientFilter(e);
      }}
      selectedClient={selectedClient?.name}
      title={"+ Supplier Client Map"}
      setViewMode={setViewMode}
      onClickRefresh={() => fetchSupplierClientMap()}
    >
      <SupplierClientMapModal
        selectedClientMapping={selectedClientMapping}
        handleClose={() => {
          setOpenModal(false);
          setSelectedClientMapping(null);
        }}
        open={openModal}
        onAddData={fetchSupplierClientMap}
      />

      {loading && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 9999,
            color: "white",
          }}
        >
          <CircularProgress color="inherit" />
        </Box>
      )}

      {shippingServiceMapData.length === 0 ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <NoDataImage />
        </div>
      ) : (
        <SupplierClientMapList
          onDeleteData={() => fetchSupplierClientMap()}
          onEditData={(e) => {
            setSelectedClientMapping(e);
            setOpenModal(true);
          }}
          data={shippingServiceMapData}
          viewMode={viewMode}
          deleteTitle={"Delete Supplier CLient Map"}
          selectedService={selectedClientMapping}
          setSelectedShippingService={setSelectedClientMapping}
          currentPage={page}
          itemsPerPage={rowsPerPage}
        />
      )}

      <CustomPagination
        dataCount={dataCount}
        rowsPerPage={rowsPerPage}
        page={page}
        setPage={setPage}
        setRowsPerPage={setRowsPerPage}
        disableNext={dataCount <= rowsPerPage * (page + 1)}
      />
    </DashboardContainer>
  );
}
